/* Skinny Genie redesign: collection page sort + mobile filter toggle. */

function sgSortCollection(value){
  var url = new URL(window.location.href);
  url.searchParams.set('sort_by', value);
  window.location.href = url.toString();
}

function toggleCategoryFilters(){
  var sidebar = document.querySelector('.category-sidebar');
  var toggle = document.getElementById('category-filter-toggle');
  if(!sidebar || !toggle) return;
  sidebar.classList.toggle('mobile-open');
  toggle.classList.toggle('open');
}
